// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 504 ? "chunk-vendors" : chunkId) + "." + {"69":"ad3bf12c0a47ce8e51ff","504":"09d0bb7412a71f78e46a"}[chunkId] + ".bundle.js";
};